var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcValueOnlineSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.729 0 0 6.729 0 15V21.2145C0 22.7505 1.3455 24 3 24H4.5C4.89782 24 5.27936 23.842 5.56066 23.5607C5.84196 23.2794 6 22.8978 6 22.5V14.7855C6 14.3877 5.84196 14.0061 5.56066 13.7248C5.27936 13.4435 4.89782 13.2855 4.5 13.2855H3.138C3.972 7.4805 8.967 3 15 3C21.033 3 26.028 7.4805 26.862 13.2855H25.5C25.1022 13.2855 24.7206 13.4435 24.4393 13.7248C24.158 14.0061 24 14.3877 24 14.7855V24C24 25.6545 22.6545 27 21 27H18V25.5H12V30H21C24.309 30 27 27.309 27 24C28.6545 24 30 22.7505 30 21.2145V15C30 6.729 23.271 0 15 0Z",
    fill: "#F54253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcValueOnlineSupport);
export default __webpack_public_path__ + "static/media/ic_value_online_support.73bee0dbf07460df77d035695d84d99c.svg";
export { ForwardRef as ReactComponent };